import "./round";

import { Storybook } from "../ui/storybook";
import { Round } from "./round";

export class RoundStoryBook extends Storybook.Default {
  title(): string {
    return "Round";
  }

  tags(): string[] {
    return ["std-round"];
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "Round",
        render: () => {
          return Round.makeWith({
            bg: "var(--blue)",
            radius: 50,
            shadow: true,
          }).assignStyles({
            width: "48px",
            height: "48px",
          });
        },
      },
      {
        title: "Continuous",
        render: () => {
          return Round.makeWith({
            bg: "var(--purple)",
            continuous: { smoothing: 0.6 },
            radius: 50,
            shadow: true,
          }).assignStyles({
            width: "48px",
            height: "48px",
          });
        },
      },
      // `clip` had six callers and no card. These two are the whole contract,
      // and they are deliberately adjacent: the first is what `clip` was built
      // for and must never change, the second is what it used to get wrong
      // (stacked children needed a filler div).
      {
        title: "Clip layers",
        render: () =>
          RoundStoryBook.clipped([
            RoundStoryBook.layer("var(--blue)", { position: "absolute", inset: "0" }),
            // A hard diagonal, so a corner that failed to clip is obvious.
            // Deliberately a gradient and NOT a clip-path: this card exists to
            // show that std-round writes no clip-path onto its children, and a
            // card that sets one itself makes that unverifiable.
            RoundStoryBook.layer("transparent", {
              position: "absolute",
              inset: "0",
              backgroundImage:
                "linear-gradient(196deg, var(--purple) 0 55%, transparent 55% 100%)",
            }),
          ]),
      },
      {
        title: "Clip stack",
        render: () =>
          RoundStoryBook.clipped([
            RoundStoryBook.layer("var(--red)", { height: "34px", flex: "0 0 auto" }),
            RoundStoryBook.layer("var(--green)", { flex: "1 1 auto" }),
          ]),
      },
    ];
  }
}

export namespace RoundStoryBook {
  /** A flat coloured box, styled by the caller — the clip cards care about
   *  WHERE it sits inside the panel, not what it looks like. */
  export function layer(bg: string, style: Partial<CSSStyleDeclaration>): HTMLElement {
    const $l = document.createElement("div");
    $l.style.background = bg;
    Object.assign($l.style, style);
    return $l;
  }

  /** A clipped panel at a size where a mis-clipped corner is visible. The
   *  children go in the LIGHT dom, which is the whole question these cards
   *  answer: a caller hands std-round its content and std-round clips it,
   *  however many pieces it arrives in. */
  export function clipped($children: HTMLElement[]): HTMLElement {
    const $r = Round.makeWith({
      clip: true,
      continuous: { smoothing: 0.6 },
      radius: 24,
      bg: "transparent",
    }).assignStyles({ width: "180px", height: "110px", flexDirection: "column" });
    $r.append(...$children);
    return $r;
  }
}
